/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import "./AboutPage.css";
import omerImage from "../images/website_Omer-10.png";
import omerImageMobile from "../images/website_Omer-40.png";
import ResearchArea from "../components/ResearchArea ";

function AboutPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="body">
      <div className="about-page">
        <div className="content">
          <div className="about-section">
            <h2 className="orange-title">ABOUT</h2>
            <p>
              I am Omer Ben Simhon, a doctoral student in the Department of
              Communication and Journalism at the Hebrew University of
              Jerusalem. My research lies at the intersection of political
              communication, attitude change, and interpersonal dynamics.
            </p>
            <p>
              My dissertation explores how political conversations shape
              societal divides. I examine, via experimental methods, the
              psychological factors that influence citizens' engagement in
              political conversations and analyze whether these conversations
              bridge or deepen political rifts. My work on political
              conversations has been presented at leading conferences such as
              ICA, APSA, ISPP, and ECPR and has received multiple awards, such
              as the SPARK Award from the APSA Political Communication Section,
              the Outstanding Thesis Award from ICA’s Interpersonal
              Communication Division, and the Dr. Yuval Shachal Prize for
              Outstanding Research Paper from the Israeli Communication
              Association.
            </p>
            <p>
              In addition to working on my dissertation, I am actively involved
              in the Experimental Political Communication Lab, funded by the ISF
              (Israel Science Foundation). In this research group, led by Dr.
              Eran Amsalem, we study the effects of extreme political rhetoric
              on individuals' emotions, attitudes, and behavior. I also lead
              another project that investigates how extreme political rhetoric
              affects individuals’ level of aggressiveness.
            </p>

            <p>
              Beyond my academic work, I have managed the Israel Sociological
              Association's social media pages and founded the social platforms
              for the journal "Media Frames" (the Israeli Journal of
              Communication). I also serve as a teaching assistant in the
              Department of Communication and Journalism at the Hebrew
              University of Jerusalem and the Department of Communication at
              Sapir College.
            </p>
          </div>
          <div className="image-section">
            <img
              src={isMobile ? omerImageMobile : omerImage}
              alt="Omer's Image"
              aria-label="Portrait of the business owner, Omer"
            />
          </div>
        </div>
        <div className="research-component">
          <ResearchArea />
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
